import * as React from 'react';
import { TitleContainer } from '../TitleContainer';
import { Link } from '../../components/Link';
import { SubtitleLayout } from '../../components/SubtitleLayout';
import { ViewContainer } from '../ViewContainer';
import { trackTwoFactorCannotConfirmClick, trackTwoFactorPopupOpen, trackTwoFactorWhatForClick } from '../../utils/tracking';
import { ETwoFactorType } from '../../types/authentication';
import { emit } from '../../actions/events';
import { EEventType } from '../../types/events';
import { FormContainer } from './containers/FormContainer';
import { HelpContainer } from '../HelpContainer';
export var TwoFactorWithPhoneViewContainer = function TwoFactorWithPhoneViewContainer(_ref) {
  var useSelector = _ref.useSelector,
      useDispatch = _ref.useDispatch;
  var dispatch = useDispatch();
  React.useEffect(function () {
    trackTwoFactorPopupOpen(ETwoFactorType.Phone);
  }, []);
  var handleWhatForClick = React.useCallback(function () {
    trackTwoFactorWhatForClick(ETwoFactorType.Phone);
    dispatch(emit(EEventType.TwoFactorWhatForClick));
  }, [dispatch]);
  var handleCannotConfirmClick = React.useCallback(function () {
    trackTwoFactorCannotConfirmClick(ETwoFactorType.Phone);
    dispatch(emit(EEventType.TwoFactorCannotConfirmClick));
  }, [dispatch]);
  return /*#__PURE__*/React.createElement(ViewContainer, null, /*#__PURE__*/React.createElement(TitleContainer, null), /*#__PURE__*/React.createElement(SubtitleLayout, null, /*#__PURE__*/React.createElement("div", null, "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u043D\u044B\u0439 \u0442\u0435\u043B\u0435\u0444\u043E\u043D \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u0430 \u0438\u043B\u0438 \u0442\u0435\u043B\u0435\u0444\u043E\u043D, \u043A\u043E\u0442\u043E\u0440\u044B\u0439 \u0443\u043A\u0430\u0437\u0430\u043D \u0432 \u0432\u0430\u0448\u0435\u043C \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0438. \u0422\u043E\u043B\u044C\u043A\u043E \u043C\u043E\u0431\u0438\u043B\u044C\u043D\u044B\u0435 \u043D\u043E\u043C\u0435\u0440\u0430."), /*#__PURE__*/React.createElement(Link, {
    href: "/help/security/37947/",
    target: "_blank",
    onClick: handleWhatForClick
  }, "\u0417\u0430\u0447\u0435\u043C \u044D\u0442\u043E \u043D\u0443\u0436\u043D\u043E")), /*#__PURE__*/React.createElement(FormContainer, null), /*#__PURE__*/React.createElement(HelpContainer, {
    text: "\u041D\u0435 \u043C\u043E\u0433\u0443 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C",
    onClick: handleCannotConfirmClick
  }));
};